import React from "react";
import Heading from "@arachnys/styleguide/Heading";
import { Row, Col } from "antd";
import style from "./styles";
import EntityInfo from "./EntityInfo";

const IndViewer = ({ entity }) => (
    <React.Fragment>
        <Heading level={0}>Basics</Heading>
        <Row gutter={17}>
            <Col md={12}>
                <Heading
                    level={1}
                    {...style.subheading}
                    style={{ marginBottom: 35 }}
                >
                    Basic Info
                </Heading>
                <Row>
                    <EntityInfo
                        entity={entity}
                        label="Entity Name"
                        path={["name"]}
                    />
                    <EntityInfo
                        entity={entity}
                        label="Local Names"
                        path={["alternativeNames", "localNames"]}
                    />
                    <EntityInfo
                        entity={entity}
                        label="Previous Names"
                        path={["alternativeNames", "previousNames"]}
                    />
                    <EntityInfo
                        entity={entity}
                        label="Short Names"
                        path={["alternativeNames", "shortNames"]}
                    />
                    <EntityInfo
                        entity={entity}
                        label="Date of Birth"
                        path={["dateOfBirth"]}
                    />
                    <EntityInfo
                        entity={entity}
                        label="Gender"
                        path={["gender"]}
                    />
                    <EntityInfo
                        entity={entity}
                        label="Nationalities"
                        path={["nationalities"]}
                        fieldName={"countryCode"}
                    />
                </Row>
                <Row>
                    <Col offset={2}>
                        <span {...style.title}>Place of Birth: </span>
                    </Col>
                </Row>
                <Row>
                    <Col offset={2} xs={22}>
                        <hr {...style.secondaryDivider} />
                    </Col>
                </Row>
                <Row>
                    <Col offset={2} xs={4}>
                        <p {...style.title}>Country:</p>
                        <p {...style.title}>City:</p>
                    </Col>
                    <Col>
                        <p>{entity.placeOfBirth.countryCode || "Unknown"}</p>
                        <p>{entity.placeOfBirth.city || "Unknown"}</p>
                    </Col>
                </Row>
            </Col>
            <Col md={12}>
                <Heading
                    level={1}
                    {...style.subheading}
                    style={{ marginBottom: 35 }}
                >
                    Physical Address
                </Heading>
                <Col offset={2} xs={5}>
                    <p {...style.title}>Street Address:</p>
                    <p {...style.title}>City:</p>
                    <p {...style.title}>Postcode:</p>
                    <p {...style.title}>Country of Residence:</p>
                    <p {...style.title}>State:</p>
                </Col>
                <Col>
                    {entity.physicalAddress != null && (
                        <React.Fragment>
                            <p>
                                {entity.physicalAddress.streetAddress ||
                                    "Unknown"}
                            </p>
                            <p>{entity.physicalAddress.city || "Unknown"}</p>
                            <p>
                                {entity.physicalAddress.postalCode || "Unknown"}
                            </p>
                            <p>
                                {entity.physicalAddress.countryCode ||
                                    "Unknown"}
                            </p>
                            <p>{entity.physicalAddress.state || "Unknown"}</p>
                        </React.Fragment>
                    )}
                </Col>
            </Col>
        </Row>

        <Heading level={0} style={{ marginTop: 30 }}>
            Identifiers and Business Information
        </Heading>
        <Row gutter={17}>
            <Col md={12}>
                <Heading
                    level={1}
                    {...style.subheading}
                    style={{ marginBottom: 35 }}
                >
                    ID Numbers
                </Heading>
                <Row gutter={10}>
                    <Col offset={2} xs={5} {...style.title}>
                        Type:
                    </Col>
                    <Col xs={7} {...style.title}>
                        Number:
                    </Col>
                    <Col xs={4} {...style.title}>
                        Status:
                    </Col>
                    <Col xs={3} {...style.title}>
                        Start date:
                    </Col>
                    <Col xs={3} {...style.title}>
                        End date:
                    </Col>
                </Row>
                <Row style={{ marginTop: 15 }}>
                    {entity.individualIdentifiers != null ? (
                        entity.individualIdentifiers.map(id => (
                            <Row
                                style={{ marginTop: 15 }}
                                gutter={10}
                                key={id.code}
                            >
                                <Col offset={2} xs={5}>
                                    {id.identifier || "Unknown"}
                                </Col>
                                <Col xs={7}>{id.code || "Unknown"}</Col>
                                <Col xs={4}>{id.status || "Unknown"}</Col>
                                <Col xs={3}>{id.startDate || "Unknown"}</Col>
                                <Col xs={3}>{id.expiryDate || "Unknown"}</Col>
                            </Row>
                        ))
                    ) : (
                        <React.Fragment>
                            <Col offset={2} xs={4}>
                                -
                            </Col>
                            <Col xs={4}>-</Col>
                            <Col xs={4}>-</Col>
                            <Col xs={4}>-</Col>
                            <Col xs={4}>-</Col>
                        </React.Fragment>
                    )}
                </Row>
            </Col>
            <Col md={12}>
                <Heading
                    level={1}
                    {...style.subheading}
                    style={{ marginBottom: 35 }}
                >
                    Business Information
                </Heading>
                <Row>
                    <Col offset={2} xs={6}>
                        <p {...style.title}>Risk Level:</p>
                        <p {...style.title}>Business Relationship:</p>
                    </Col>
                    <Col>
                        <p>{entity.riskLevel}</p>
                        <p>{entity.businessRelationship}</p>
                    </Col>
                </Row>
            </Col>
        </Row>

        <Heading level={0} style={{ marginTop: 30 }}>
            Financial Info
        </Heading>
        <Row gutter={17}>
            <Heading
                level={1}
                {...style.subheading}
                style={{ marginBottom: 35 }}
            >
                Financial Information
            </Heading>
            <Col md={12}>
                <Col offset={2} sm={10}>
                    <p {...style.title}>Total Assets:</p>
                    <p {...style.title}>Source of Wealth:</p>
                </Col>
                <Col sm={10}>
                    <p>{entity.totalAssets || "Unknown"}</p>
                    <p>{entity.sourceOfWealth || "Unknown"}</p>
                </Col>
            </Col>
            <Col md={12}>
                <Col offset={2} sm={10}>
                    <p {...style.title}>Total Annual Revenue:</p>
                    <p {...style.title}>Fiscal Year End Date:</p>
                </Col>
                <Col sm={10}>
                    <p>{entity.totalAnnualRevenue || "Unknown"}</p>
                    <p>{entity.fiscalYearEndDate || "Unknown"}</p>
                </Col>
            </Col>
        </Row>
    </React.Fragment>
);

export default IndViewer;
